import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';

const QuestionnairePreviousButton = ({ onClick, children, ...props }) => {
  return (
    <Button variant="outlined" onClick={onClick} {...props}>
      {children}
    </Button>
  );
};

QuestionnairePreviousButton.defaultProps = {
  onClick: PropTypes.func,
};

QuestionnairePreviousButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default QuestionnairePreviousButton;
